import { MRT_BLUE_STATION_ID, Line, METRO_STATION_ID } from "../types";

export const MRT_BLUE_LINE: Line = { 
    line: [
        MRT_BLUE_STATION_ID.CHARAN_13,
        MRT_BLUE_STATION_ID.FAI_CHAI,
        MRT_BLUE_STATION_ID.BANG_KHUN_NON,
        MRT_BLUE_STATION_ID.BANG_YI_KHAN,
        MRT_BLUE_STATION_ID.SIRINDHORN,
        MRT_BLUE_STATION_ID.BANG_PHLAT,
        MRT_BLUE_STATION_ID.BANG_O,
        MRT_BLUE_STATION_ID.BANG_PHO,
        MRT_BLUE_STATION_ID.TAO_POON,
        MRT_BLUE_STATION_ID.BANG_SUE,
        MRT_BLUE_STATION_ID.KAMPHAENG_PHET,
        MRT_BLUE_STATION_ID.CHATUCHAK_PARK,
        MRT_BLUE_STATION_ID.PHAHON_YOTHIN,
        MRT_BLUE_STATION_ID.LAT_PHRAO,
        MRT_BLUE_STATION_ID.RATCHADAPHISEK,
        MRT_BLUE_STATION_ID.SUTTHISAN,
        MRT_BLUE_STATION_ID.HUAI_KHWANG,
        MRT_BLUE_STATION_ID.THAILAND_CULTURAL_CENTRE,
        MRT_BLUE_STATION_ID.PHRA_RAM_9,
        MRT_BLUE_STATION_ID.PHETCHABURI,
        MRT_BLUE_STATION_ID.SUKHUMVIT,
        MRT_BLUE_STATION_ID.QUEEN_SIRIKIT_NATIONAL_CONVENTION_CENTRE,
        MRT_BLUE_STATION_ID.KHLONG_TOEI,
        MRT_BLUE_STATION_ID.LUMPHINI,
        MRT_BLUE_STATION_ID.SILOM,
        MRT_BLUE_STATION_ID.SAM_YAN,
        MRT_BLUE_STATION_ID.HUA_LAMPHONG,
        MRT_BLUE_STATION_ID.WAT_MANGKON,
        MRT_BLUE_STATION_ID.SAM_YOT,
        MRT_BLUE_STATION_ID.SANAM_CHAI,
        MRT_BLUE_STATION_ID.ITSARAPHAP,
        MRT_BLUE_STATION_ID.THAPHRA,
        MRT_BLUE_STATION_ID.BANG_PHAI,
        MRT_BLUE_STATION_ID.BANG_WA,
        MRT_BLUE_STATION_ID.PHETKASEM_48,
        MRT_BLUE_STATION_ID.PHASI_CHAROEN,
        MRT_BLUE_STATION_ID.BANG_KHAE,
        MRT_BLUE_STATION_ID.LAK_SONG,
    ],
    intersections: [
        [MRT_BLUE_STATION_ID.THAPHRA, MRT_BLUE_STATION_ID.CHARAN_13],
    ]
};

export const MRT_BLUE_CYCLE: METRO_STATION_ID[] = [
    MRT_BLUE_STATION_ID.THAPHRA,
    MRT_BLUE_STATION_ID.CHARAN_13,
    MRT_BLUE_STATION_ID.FAI_CHAI,
    MRT_BLUE_STATION_ID.BANG_KHUN_NON,
    MRT_BLUE_STATION_ID.BANG_YI_KHAN,
    MRT_BLUE_STATION_ID.SIRINDHORN,
    MRT_BLUE_STATION_ID.BANG_PHLAT,
    MRT_BLUE_STATION_ID.BANG_O,
    MRT_BLUE_STATION_ID.BANG_PHO,
    MRT_BLUE_STATION_ID.TAO_POON,
    MRT_BLUE_STATION_ID.BANG_SUE,
    MRT_BLUE_STATION_ID.KAMPHAENG_PHET,
    MRT_BLUE_STATION_ID.CHATUCHAK_PARK,
    MRT_BLUE_STATION_ID.PHAHON_YOTHIN,
    MRT_BLUE_STATION_ID.LAT_PHRAO,
    MRT_BLUE_STATION_ID.RATCHADAPHISEK,
    MRT_BLUE_STATION_ID.SUTTHISAN,
    MRT_BLUE_STATION_ID.HUAI_KHWANG,
    MRT_BLUE_STATION_ID.THAILAND_CULTURAL_CENTRE,
    MRT_BLUE_STATION_ID.PHRA_RAM_9,
    MRT_BLUE_STATION_ID.PHETCHABURI,
    MRT_BLUE_STATION_ID.SUKHUMVIT,
    MRT_BLUE_STATION_ID.QUEEN_SIRIKIT_NATIONAL_CONVENTION_CENTRE,
    MRT_BLUE_STATION_ID.KHLONG_TOEI,
    MRT_BLUE_STATION_ID.LUMPHINI,
    MRT_BLUE_STATION_ID.SILOM,
    MRT_BLUE_STATION_ID.SAM_YAN,
    MRT_BLUE_STATION_ID.HUA_LAMPHONG,
    MRT_BLUE_STATION_ID.WAT_MANGKON,
    MRT_BLUE_STATION_ID.SAM_YOT,
    MRT_BLUE_STATION_ID.SANAM_CHAI,
    MRT_BLUE_STATION_ID.ITSARAPHAP
]

export const MRT_BLUE_TAIL: METRO_STATION_ID[] = [
    MRT_BLUE_STATION_ID.THAPHRA,
    MRT_BLUE_STATION_ID.BANG_PHAI,
    MRT_BLUE_STATION_ID.BANG_WA,
    MRT_BLUE_STATION_ID.PHETKASEM_48,
    MRT_BLUE_STATION_ID.PHASI_CHAROEN,
    MRT_BLUE_STATION_ID.BANG_KHAE,
    MRT_BLUE_STATION_ID.LAK_SONG,
]